import { faChevronDown, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Props } from '@/pages/Profile/components/HiddenCardsDivider/types';
import { cn } from '@/ui/lib/utils';

/**
 * The one line hidden cards collapse behind at the bottom of the page. It reads as a divider
 * rather than a card so it doesn't compete with the cards still showing, and opening it lays the
 * hidden cards out below it.
 */
const HiddenCardsDivider = ({ count, isOpen, onToggle }: Props) => (
  <button
    aria-expanded={isOpen}
    className="group flex w-full items-center gap-3 rounded py-3 text-xs font-medium text-uniform-gray-500 hover:text-uniform-gray-700 [outline:none] focus-visible:ring-2 focus-visible:ring-uniform-gray-400 dark:text-uniform-gray-400 dark:hover:text-uniform-gray-200"
    type="button"
    onClick={onToggle}>
    <span className="h-px flex-1 bg-uniform-gray-200 dark:bg-uniform-gray-700" />
    <span className="flex items-center gap-1.5">
      <FontAwesomeIcon icon={faEyeSlash} />
      {`${count} ${count === 1 ? 'card' : 'cards'} hidden`}
      <FontAwesomeIcon
        className={cn('h-2.5 w-2.5 transition-transform', !isOpen && '-rotate-90')}
        icon={faChevronDown}
      />
    </span>
    <span className="h-px flex-1 bg-uniform-gray-200 dark:bg-uniform-gray-700" />
  </button>
);

export default HiddenCardsDivider;
